const BOOK_STRUCTURE = {
  NARRATIVE_NONFICTION: 'Narrative Nonfiction (Chronological)',
  TOPIC_BASED: 'Topic-Based (Thematic)',
};

module.exports = BOOK_STRUCTURE;
